






























































































































































































































































































































import Vue from 'vue';
import dayjs from 'dayjs';
import api from '../services/api';
import eventBus from '@/services/eventBus';
import CheckBox from '@/components/CheckBox.vue';
import DateInput from '@/components/DateInput.vue';
import LookupComboBox from '@/modules/transactions/components/LookupComboBox.vue';
import ValidationError from '@/modules/downPayment/components/ValidationError.vue';
import TransactionApi from '@/modules/transactions/services/TransactionApi';
import { Year } from '../models/YearModell';
import { Period } from '../models/PeriodModell';
import { t } from "@/plugins/i18n";

interface AccRow {
    id: number;
    accno: string;
    name: string;
    targetAccno: string;
    targetName: string;
    selected: boolean;
    // K2D mmbokaccno.is_p_open_close: ez a főkönyvi szám csak partnerenkénti bontással könyvelhető
    // (a fej "Partnerenként" kapcsolójától függetlenül is kikényszeríti a bontást, ld. error computed).
    isPartnerOpenClose: boolean;
}
interface ModeTab {
    value: string;
    title: string;
}
interface Data {
    modeIndex: number;
    yearId: number | null;
    years: Year[];
    accounts: AccRow[];
    accDate: string;
    accEvent: string;
    remark: string;
    isPartner: boolean;
    hideTransferred: boolean;
    noManagement: boolean;
    showDetails: boolean;
    detailAccount: AccRow | null;
    detailRows: any[];
    detailColumns: any[];
    periods: Period[];
    bookTypes: any[];
    bookTypeId: number;
    dimensionOptions: any[];
    dimTypes: any[];
    dimcodes: number[];
    dimDisplay: string[];
    busy: boolean;
    columns: any[];
}
interface Methods {
    loadYears(): Promise<void>;
    loadAccounts(): Promise<void>;
    loadPeriods(): Promise<void>;
    loadDimensions(): Promise<void>;
    loadDimTypes(): Promise<void>;
    loadBookTypes(): Promise<void>;
    loadDefaultBookType(): Promise<void>;
    dimItemsForSlot(index: number): any[];
    onDimChange(index: number, selected: any): void;
    toggleSelect(item: AccRow, value: boolean): void;
    selectAll(): void;
    clearAll(): void;
    onRowClick(e: any): void;
    rowRender(h: any, trElement: any, defaultSlots: any, props: any): any;
    loadDetail(): Promise<void>;
    formatNumber(n: number): string;
    book(): Promise<void>;
}
interface Computed {
    modeTabs: ModeTab[];
    mode: string;
    yearItems: { id: number; label: string }[];
    selectedCount: number;
    modeLabel: string;
    canBook: boolean;
    error: string;
    periodName: string;
    dimSlotCount: number;
    dimRows: number[][];
}

export default Vue.extend<Data, Methods, Computed, {}>({
    components: { CheckBox, DateInput, LookupComboBox, ValidationError },
    data() {
        return {
            modeIndex: 0,
            yearId: null,
            years: [],
            accounts: [],
            accDate: '',
            accEvent: '',
            remark: '',
            isPartner: false,
            hideTransferred: true,
            noManagement: true,
            showDetails: false,
            detailAccount: null,
            detailRows: [],
            periods: [],
            bookTypes: [],
            bookTypeId: 0,
            dimensionOptions: [],
            dimTypes: [],
            dimcodes: Array(9).fill(1),
            dimDisplay: Array(9).fill(''),
            busy: false,
            columns: [
                { cell: 'selectTemplate', title: t("GeneralLedger_Kijelol"), width: '90px', headerClassName: 'center_text' },
                { field: 'accno', title: t("FokonyviSzam"), width: '160px' },
                { field: 'name', title: t("Megnevezes") },
                { field: 'targetAccno', title: t("GeneralLedger_CelFokonyviSzam"), width: '160px' },
                { field: 'targetName', title: t("GeneralLedger_CelMegnevezes") },
            ],
            detailColumns: [
                { field: 'partnerName', title: t("Partner") },
                { field: 'city', title: t("Varos"), width: '160px' },
                { field: 'address', title: t("Cim") },
                { field: 'debit', title: t("Tartozik"), width: '150px', cell: 'debitCell' },
                { field: 'credit', title: t("Kovetel"), width: '150px', cell: 'creditCell' },
                { field: 'balance', title: t("Egyenleg"), width: '150px', cell: 'balanceCell' },
            ],
        };
    },
    async mounted() {
        await this.loadBookTypes();
        await this.loadDefaultBookType();
        await this.loadDimTypes();
        await this.loadYears();
    },
    watch: {
        yearId() {
            this.loadAccounts();
            this.loadPeriods();
            this.loadDimensions();
        },
        mode() {
            this.loadAccounts();
            this.loadDefaultBookType();
        },
        hideTransferred() {
            this.loadAccounts();
        },
        // "Mutassa részletezve is": kikapcsolva ürítjük a részletezést (K2D dw_2.reset()), bekapcsolva újratöltjük a kiválasztott sorra.
        showDetails(val) {
            if (!val) {
                this.detailAccount = null;
                this.detailRows = [];
            } else if (this.detailAccount) {
                this.loadDetail();
            }
        },
    },
    methods: {
        async loadYears() {
            try {
                this.years = await api.GetGeneralLedgerYears();
                if (this.years.length > 0 && !this.yearId) {
                    // Alapértelmezett: a mai dátum szerinti könyvelési év (ha van), különben a legújabb.
                    const currentYear = new Date().getFullYear();
                    const match = this.years.find((y) => y.year === currentYear);
                    this.yearId = match ? match.id : this.years[0].id;
                }
            } catch (e) {
                eventBus.$emit('error', t("GeneralLedger_AKonyvelesiEvekBetolteseNemSikerult"));
            }
        },
        async loadAccounts() {
            // A lista cseréjekor a részletezés a korábbi sorra már nem érvényes.
            this.detailAccount = null;
            this.detailRows = [];
            if (!this.yearId) {
                this.accounts = [];
                return;
            }
            try {
                // K2D w_popup_zaras dw_1: mód-specifikus szűrés (status / is_open|is_close|is_across / cél FKsz / nyitásnál záró tranzakció)
                const list = await api.GetOpenCloseAccounts(
                    this.yearId,
                    this.mode,
                    this.mode === 'A' ? this.hideTransferred : false,
                );
                this.accounts = (list || []).map((a) => ({
                    id: a.id,
                    accno: a.accno,
                    name: a.name || '',
                    targetAccno: a.targetAccno || '-',
                    targetName: a.targetName || '-',
                    selected: false,
                    isPartnerOpenClose: !!a.isPartnerOpenClose,
                }));
            } catch (e) {
                eventBus.$emit('error', t("GeneralLedger_AFokonyviSzamokBetolteseNemSikerult"));
                this.accounts = [];
            }
        },
        // Az év periódusai – a Periódus mező a könyvelési dátumból ezekből oldódik fel.
        async loadPeriods() {
            if (!this.yearId) {
                this.periods = [];
                return;
            }
            try {
                this.periods = await api.GetPeriods(this.yearId);
            } catch (e) {
                this.periods = [];
            }
        },
        // Az év dimenziókódjai (mmbokdimcode) a fej Dimenzió 1–9 választókhoz. Évváltáskor a korábbi választás törlődik.
        async loadDimensions() {
            this.dimcodes = Array(9).fill(1);
            this.dimDisplay = Array(9).fill('');
            const year = this.years.find((y) => y.id === this.yearId);
            if (!year) {
                this.dimensionOptions = [];
                return;
            }
            try {
                this.dimensionOptions = await TransactionApi.getDimensions(String(year.year));
            } catch (e) {
                this.dimensionOptions = [];
            }
        },
        // Dimenziótípusok (csaccdimcodetype) szám szerint rendezve – a slot N a sorrendben N. típust (pl. IV. dimenzió) szűri.
        async loadDimTypes() {
            try {
                const types = await api.GetDimCodeTypes();
                this.dimTypes = (types || [])
                    .filter((t: any) => t.id > 1)
                    .sort((a: any, b: any) => a.id - b.id);
            } catch (e) {
                this.dimTypes = [];
            }
        },
        // Naplótípusok (csbokbooktype) a Napló típus legördülőhöz.
        async loadBookTypes() {
            try {
                this.bookTypes = await TransactionApi.getBookTypes();
            } catch (e) {
                this.bookTypes = [];
            }
        },
        // A mód szerinti alapértelmezett naplótípus előválasztása (K2D: csboktranstype.book_type).
        async loadDefaultBookType() {
            try {
                this.bookTypeId = await api.GetOpenCloseDefaultBookType(this.mode);
            } catch (e) {
                this.bookTypeId = 0;
            }
        },
        // Egy dimenzió-slot (0..8) választható kódjai: csak az adott slothoz tartozó dimenziótípus kódjai.
        dimItemsForSlot(index) {
            const type = this.dimTypes[index];
            if (!type) {
                return [];
            }
            return this.dimensionOptions.filter((d: any) => d.type === type.id);
        },
        // Egy dimenzió-slot (1..9) értékének beállítása a választóból (kód id-ja + megjelenített kód).
        onDimChange(index, selected) {
            if (selected && selected.id > 1) {
                this.$set(this.dimcodes, index, selected.id);
                this.$set(this.dimDisplay, index, selected.dimcode);
            } else {
                this.$set(this.dimcodes, index, 1);
                this.$set(this.dimDisplay, index, '');
            }
        },
        toggleSelect(item, value) {
            item.selected = value;
        },
        selectAll() {
            this.accounts.forEach((a) => { a.selected = true; });
        },
        clearAll() {
            this.accounts.forEach((a) => { a.selected = false; });
        },
        // K2D dw_1::rowfocuschanged: ha a "Mutassa részletezve is" be van kapcsolva, a kattintott sorhoz betöltjük a részletezést.
        onRowClick(e) {
            if (!this.showDetails) {
                return;
            }
            this.detailAccount = e.dataItem;
            this.loadDetail();
        },
        // A részletezett (kattintott) sor kiemelése, ha a "Mutassa részletezve is" be van kapcsolva —
        // így látszik, melyik FKsz tételeit mutatja az alsó rács (BookingTemplateEditor selected-row minta).
        rowRender(h, trElement, defaultSlots, props) {
            const active = this.showDetails && this.detailAccount && this.detailAccount.id === props.dataItem.id;
            return h(
                trElement.tag,
                {
                    ...trElement.data,
                    class: [trElement.data && trElement.data.class, active ? 'selected-row' : ''],
                },
                trElement.children,
            );
        },
        // A kiválasztott FKsz partnerenkénti bontása (K2D dw_2 / d_g_zaras).
        async loadDetail() {
            if (!this.yearId || !this.detailAccount) {
                this.detailRows = [];
                return;
            }
            try {
                this.detailRows = await api.GetOpenCloseAccountDetail(
                    this.yearId,
                    this.detailAccount.id,
                    this.mode,
                    this.isPartner,
                );
            } catch (e) {
                this.detailRows = [];
            }
        },
        formatNumber(n) {
            if (n === null || n === undefined) {
                return '';
            }
            return Number(n).toLocaleString('hu-HU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },
        async book() {
            if (!this.canBook) {
                return;
            }
            this.busy = true;
            try {
                const res = await api.BookOpenClose({
                    mode: this.mode,
                    yearId: this.yearId as number,
                    accDate: this.accDate,
                    accEvent: this.accEvent,
                    remark: this.remark,
                    // K2D w_popup_zaras: a "Partnerenként" kapcsoló mindhárom módban hat (d_f_zaras_fej
                    // checkboxa nincs módhoz kötve), nem csak Átvezetésnél.
                    isPartner: this.isPartner,
                    noManagement: this.noManagement,
                    bookType: this.bookTypeId,
                    dimcodes: this.dimcodes,
                    accnoIds: this.accounts.filter((a) => a.selected).map((a) => a.id),
                });
                if (res.success) {
                    eventBus.$emit('success', res.message);
                    this.clearAll();
                    await this.loadAccounts();
                } else {
                    eventBus.$emit('error', res.message);
                }
            } catch (e) {
                eventBus.$emit('error', t("GeneralLedger_AKonyvelesNemSikerult"));
            } finally {
                this.busy = false;
            }
        },
    },
    computed: {
        modeTabs() {
            return [
                { value: 'N', title: t("Nyitas") },
                { value: 'Z', title: t("GeneralLedger_Zaras") },
                { value: 'A', title: t("GeneralLedger_Atvezetes") },
            ];
        },
        mode() {
            return (this.modeTabs[this.modeIndex] || this.modeTabs[0]).value;
        },
        yearItems() {
            return this.years.map((y) => ({ id: y.id, label: y.name || String(y.year) }));
        },
        selectedCount() {
            return this.accounts.filter((a) => a.selected).length;
        },
        modeLabel() {
            return this.mode === 'N' ? t("Nyitas") : this.mode === 'Z' ? t("GeneralLedger_Zaras") : t("GeneralLedger_Atvezetes");
        },
        canBook() {
            return this.error === '';
        },
        // A mentés (könyvelés) előfeltételei – az első hiányzó kötelező mező üzenete jelenik meg a piros felkiáltójelnél.
        error() {
            if (!this.yearId) {
                return t("GeneralLedger_KonyvelesiEvKivalasztasaKotelezo");
            }
            if (!this.accDate) {
                return t("GeneralLedger_KonyvelesDatumaKitolteseKotelezo");
            }
            if (this.periodName === '-') {
                return t("GeneralLedger_NincsAKonyvelesDatumahozTartozoPeriodus");
            }
            if (!this.accEvent) {
                return t("GeneralLedger_GazdasagiEsemenyKitolteseKotelezo");
            }
            if (this.selectedCount === 0) {
                return t("GeneralLedger_LegalabbEgyFokonyviSzamKijeloleseKotelezo");
            }
            // K2D w_popup_zaras: ha a "Partnerenként" kapcsoló KI van kapcsolva, egyetlen kijelölt
            // főkönyvi szám sem lehet partner-szintű nyitás/zárás kötelezettségű
            // (mmbokaccno.is_p_open_close) — az ilyen számok csak partnerenkénti bontással könyvelhetők.
            if (!this.isPartner) {
                const blocked = this.accounts
                    .filter((a) => a.selected && a.isPartnerOpenClose)
                    .map((a) => a.accno);
                if (blocked.length > 0) {
                    return t("GeneralLedger_AZFokonyviSzamCsakPartnerenkent", [blocked.join(', ')]);
                }
            }
            return '';
        },
        // Periódus a könyvelési dátumból (az év periódusai közül a dátumot tartalmazó).
        periodName() {
            if (!this.accDate || this.periods.length === 0) {
                return '-';
            }
            const t = dayjs(this.accDate).valueOf();
            const p = this.periods.find(
                (x) => dayjs(x.startDate).valueOf() <= t && t <= dayjs(x.endDate).valueOf(),
            );
            return p ? p.period : '-';
        },
        // Megjelenített dimenzió-slotok száma: a K2D fej legfeljebb 9 dimenziókódot tárol (dimcode1..9).
        dimSlotCount() {
            return Math.min(9, this.dimTypes.length);
        },
        // A dimenzió-slotok 3-as csoportokra bontva (soronként 3): [[1,2,3],[4,5,6],[7,8,9]].
        dimRows() {
            const rows: number[][] = [];
            for (let i = 0; i < this.dimSlotCount; i += 3) {
                const group: number[] = [];
                for (let k = i + 1; k <= Math.min(i + 3, this.dimSlotCount); k++) {
                    group.push(k);
                }
                rows.push(group);
            }
            return rows;
        },
    },
});
